import DespesasRotas from "./despesas/DespesasRotas"
import PagamentosRotas from "./pagamento/PagamentosRotas"

export default {
    path: 'finalizacao',
    name: 'DespesasGerais_Finalizacao',
    component: {
        render(c) {
            return c('router-view')
        }
    }, 
    children: [DespesasRotas, PagamentosRotas]
}